/**
 * INERT.
 *
 * The sitewide Organization + LocalBusiness JSON-LD is emitted by the root
 * route's server-rendered `head()` in src/routes/__root.tsx, so it is present
 * in the SSR HTML exactly once per page. Injecting it again on the client would
 * duplicate the `@id` entities.
 */
const GlobalSchema = () => null;

export default GlobalSchema;
